import React, { useContext, useEffect } from "react";

import { ContentStyleContext } from "./ViewContainer";

function withContentStyle(borderPadding: "noborder" | "border", Component: React.ComponentType<any>) {
    return (props: any) => {
        const styleCtx = useContext(ContentStyleContext);
        useEffect(() => {
            styleCtx.setBorderStyle(borderPadding);

            return () => {
                // Reset to having a border
                styleCtx.setBorderStyle("border");
            };
        // If we include 'styleCtx' like the warning states, we end up in an infinite update loop
        // eslint-disable-next-line
        }, []);

        return <Component {...props} />;
    };
}

export default withContentStyle;
